import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce8064a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ttn-invoices" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "ttn-invoices__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__title" }, "Накладные", -1))
const _hoisted_5 = { class: "header__count" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "ttn-invoices__content"
}
const _hoisted_9 = { class: "content__container" }
const _hoisted_10 = {
  key: 0,
  class: "ttn-invoices__content"
}
const _hoisted_11 = { class: "content__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ttn_invoices_table = _resolveComponent("ttn-invoices-table")!
  const _component_ttn_view_manager = _resolveComponent("ttn-view-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.directions.reduce((total, current) => total + current.invoiceCount, 0)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_button, {
          type: "button",
          class: "small primary",
          loading: _ctx.state.is_export_loading,
          onClick: _ctx.exportExcel
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Выгрузить Excel ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _createVNode(_component_ttn_view_manager, {
      value: _ctx.state.view,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.view) = $event)),
      class: "mt-6"
    }, {
      sector: _withCtx(() => [
        (_ctx.directionsTwo.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directionsTwo, (direction) => {
                  return (_openBlock(), _createBlock(_component_ttn_invoices_table, {
                    key: direction.sectorId,
                    direction: direction,
                    "view-key": _ctx.state.view
                  }, null, 8, ["direction", "view-key"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      direction: _withCtx(() => [
        (_ctx.directions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directions, (direction) => {
                  return (_openBlock(), _createBlock(_component_ttn_invoices_table, {
                    key: direction.directionId,
                    direction: direction,
                    "view-key": _ctx.state.view
                  }, null, 8, ["direction", "view-key"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}